import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {FormattedMessage} from 'react-intl';
import {Button, Icon} from 'semantic-ui-react';
import setDisplayName from 'recompose/setDisplayName';
import {openModal} from './actions';

export default compose(
  setDisplayName('DateRangeButton'),
  connect(null, {onClick: openModal})
)(props => (
  <Button primary onClick={props.onClick} className='date-range-button'>
    <Icon name='calendar alternate outline' />
    <FormattedMessage id='dateRange.button' />
  </Button>
));



// WEBPACK FOOTER //
// ./public/components/DateRange/DateRangeButton.jsx